export default {
  Payroll: 'Payroll',
  Posted: 'Posted',
  Instructed: 'Instructed',
  'Date from': 'Date from',
  'Date to': 'Date to',
  Status: 'Status',
  Employee: 'Employee',
  CONSENT: 'Consent',
  INITIAL: 'Initial',
  IN_PROGRESS: 'In Progress',
  COMPLETED_WITH_ERRORS: 'With errors',
  REJECTED: 'Rejected',
  COMPLETED: 'Completed',
  'Instructed amount': 'Instructed amount',
  'Posted amount': 'Posted amount',
  Description: 'Description',
  'Number of records': 'Number of records',
  'Executed by': 'Executed by',
  Date: 'Date',
  'Date and time': 'Date and time',
  'Transaction details': 'Transaction details',
  Account: 'Account',
  'List of records': 'List of records',
  'Some records are being processed. Click "Refresh" to update statuses':
    'Some records are being processed. Click "Refresh" to update statuses',
  Refresh: 'Refresh',
  'Number of payments': 'Number of payments',
  'Load more': 'Load more',
  'All loaded': 'All loaded',
  'Account number': 'Account number',
  Amount: 'Amount',
  Name: 'Name',
  'Transfer status': 'Transfer status',
  'Ready to pay': 'Ready to pay',
  'Unable to pay': 'Unable to pay',
  'User guide to payroll': 'User guide to payroll',
  downloadTemplate: 'Download the <1>CSV template</1>',
  'Fill in the following data for each beneficiary':
    'Fill in the following data for each beneficiary:',
  'Account number or phone number (format ‘P_’, then country code and rest of number, e.g. ‘P_971501234567’)':
    'Account number or phone number (format ‘P_’, then country code and rest of number, e.g. ‘P_971501234567’)',
  'Transfer amount': 'Transfer amount',
  'Full name': 'Full name',
  'Payment description': 'Payment description',
  enterDetails:
    'Enter the <strong>total amount of records</strong> and the <strong>total transfer amount</strong>.',
  'Click "Run Payroll" button to start the flow.': 'Click "Run Payroll" button to start the flow.',
  'Select the account to debit and enter the required details and upload the CSV file.':
    'Select the account to debit and enter the required details and upload the CSV file.',
  readyToPayStatus:
    'To complete the transfer, all entries must have a status <strong>"Ready to pay"</strong>.',
  'In case of any errors fix the document data and re-upload the file.':
    'In case of any errors fix the document data and re-upload the file.',
  'Verify your transfer details and complete the operation.':
    'Verify your transfer details and complete the operation.',
  'Run Payroll': 'Run Payroll',
  'Enter payment details': 'Enter payment details',
  'Verify beneficiaries list': 'Verify beneficiaries list',
  'Account to debit': 'Account to debit',
  payrollGuide: 'Need help? See our <1>user guide to payroll</1>',
  'Payment details': 'Payment details',
  'Enter value': 'Enter value',
  'Total amount to pay': 'Total amount to pay',
  'Enter amount': 'Enter amount',
  'Please upload the filled CSV file to proceed': 'Please upload the filled CSV file to proceed',
  'Click or drag file to this area to upload': 'Click or drag file to this area to upload',
  'Support for a single upload. Strictly prohibited from uploading company data or other banned files.':
    'Support for a single upload. Strictly prohibited from uploading company data or other banned files.',
  Total: 'Total',
  'Fix CSV file and re-upload': 'Fix CSV file and re-upload',
  transfer: 'Transfer {{amount}}',
  'Payroll has been initiated': 'Payroll has been initiated',
  'From account': 'From account',
  'Recipients will receive': 'Recipients will receive',
  'Row #': 'Row #',
  Currency: 'Currency',
  payrollBatchCurrencyNote:
    'Payroll batches support one currency per batch.<br/>To process multiple currencies, create separate batches for each currency.',
};
